/* eslint-disable camelcase */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import { Row, Col, Tooltip, OverlayTrigger } from 'react-bootstrap'
import moment from 'moment'
import CustomProgressBar from '../../../../shared/components/CustomProgressBar'

import LCRPStudyPlanItem from '../../LCRP-StudyPlanItem'
import StudyPlanItem from '../../../../lcrp/components/StudyPlanItem'
import TopicItem from './item'
import Clickable from '../../Clickable'
import calculateTotalTime from '../../../../lcrp/lib/calculateTime'
import { msToTime } from '../../../../shared/containers/InstructorPage'

import redDot from 'Assets/redDot.svg'
import yellowDot from 'Assets/yellowDot.svg'
import greenDot from 'Assets/greenDot.svg'
import caretRight from 'Assets/caret-right-acqua.svg'
import caretDown from 'Assets/caret-down-acqua.svg'

import panelStyle from 'Styles/panel.css'
import progressBarStyle from 'Styles/progress-bar.css'
import style from './style.css'
import iconStyle from 'Styles/icon.css'
import closeIcon from 'Assets/x-icon-gray.svg'
import base from 'Styles/base.css'

export default class TopicPerformanceDetail extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showRetakeCharts: false,
      showClassComparison: false,
      showScoreDetails: false,
      showRetakeDetails: false
    }

    this.onToggleRetakeCharts = this.onToggleRetakeCharts.bind(this)
    this.onCheckboxSelected = this.onCheckboxSelected.bind(this)
  }

  // If we deselect a student while showRetakeCharts is true, reset it to false
  // Or if we select another student without multiple retakes, reset it to false
  componentWillReceiveProps (nextProps) {
    if (nextProps.selectedStudent === null) {
      this.setState({
        showRetakeCharts: false,
        showClassComparison: false
      })
    } else if (nextProps.selectedStudent.lcrp_progress == undefined && this.state.showRetakeCharts) { // eslint-disable-line eqeqeq
      this.setState({ showRetakeCharts: false })
    } else if (nextProps.selectedStudent.lcrp_progress == undefined && !this.state.showRetakeCharts) { // eslint-disable-line eqeqeq

    } else if (
      nextProps.selectedStudent.lcrp_progress.ra &&
      nextProps.selectedStudent.lcrp_progress.ra.length === 0 &&
      this.state.showRetakeCharts
    ) {
      this.setState({ showRetakeCharts: false })
    }
  }

  onCheckboxSelected (e) {
    if (e.target.checked) {
      this.setState({ showClassComparison: true })
    } else {
      this.setState({ showClassComparison: false })
    }
  }

  onToggleRetakeCharts () {
    this.setState({
      showRetakeCharts: !this.state.showRetakeCharts,
      showClassComparison: false
    })
  }

  generateSlices (score) {
    let chartColor
    if (score < 70) {
      chartColor = '#DA1B2C' // --prs-c-red-500
    } else if (score >= 70 && score < 90) {
      chartColor = '#E5D676' // --prs-c-yellow-400
    } else { // percentage >= 90
      chartColor = '#68B75F' // --prs-c-green-400
    }
    return (
      [
        {
          color: '#fff',
          value: 100 - score
        },
        {
          color: chartColor,
          value: score
        }
      ]
    )
  }

  renderAccuracyBar (score) {
    return (
      <CustomProgressBar
        dataTestId="averageAccuracyBar"
        now={score}
        min={0}
        max={100}
        ariaLabel={`You have ${score} points.`}
        progressBarStyle={progressBarStyle}
        style={style}
        className={classnames(progressBarStyle.base, style.progressBar)}
        bsClass={classnames(progressBarStyle.progressValueBase, style.progressBarValue)}
      />
    )
  }

  // This panel displays first attempt and all retakes for selectedStudent, if 2 or more retakes exist
  // It has its own instance methods, but shares some with renderRecentRetakes()
  renderAllRetakes () {
    const { selectedStudent, browser } = this.props
    const { activity_state, lcrp_progress } = selectedStudent
    const { width } = browser
    const isMobile = width < 769
    const firstAtttemptObj = _.pick(activity_state, ['tp', 'score', 'target'])
    const recentRetakeObj = _.pick(activity_state.rt, ['tp', 'score', 'target', 'qr'])
    const progressArray = [firstAtttemptObj, ...lcrp_progress.ra, recentRetakeObj]
    const isMobileStudentDetail = isMobile && selectedStudent

    return (
      <div>
        <div key="all-retakes-header" className={selectedStudent != null ? style.retakeHeader : panelStyle.base}>
          <h2 className={style.studyPlanHeader} data-test-id="activityPerformanceLabel">
            {`Activity Performance: ${selectedStudent.name}`}
          </h2>
          <button
            data-test-id="closeStudentDetailBtn"
            aria-label="Close student detail"
            className={classnames(!isMobileStudentDetail && style.hide, style.hideDetail)}
            onClick={this.props.onBackClick}
            tabIndex="0"
          >
            <object
              tabIndex="-1"
              data={closeIcon} type="image/svg+xml"
              className={base.svgIcon}
            />
          </button>
          <div>
            <input
              type="checkbox"
              name="classScoreSelected"
              aria-label={'Class Average Checkbox'}
              defaultChecked={false}
              onChange={this.onCheckboxSelected}
              tabIndex="0"
              id="classAverageCheckboxAllRetakes"
            />
            <label
              className={style.classAverageLabel}
              htmlFor="classAverageCheckboxAllRetakes"
            >
              <span className={style.classAverageCheckbox} data-test-id="tpdShowClassAverage">
                Show Class Average Comparisons
              </span>
              {!isMobile &&
                selectedStudent.lcrp_progress.ra.length > 0
                ? <span className={style.viewRetakesLabel} onClick={this.onToggleRetakeCharts}>
                  View Most Recent Retake
                </span>
                : null}
            </label>
          </div>
        </div>
        {this.renderOldRetakeCharts(progressArray)}
        {isMobile &&
         selectedStudent.lcrp_progress.ra.length > 0
          ? (
            <button className={classnames(panelStyle.base, style.mobileRetakeButton)} onClick={this.onToggleRetakeCharts}>
            View Most Recent Retake
            </button>
            )
          : null}
      </div>
    )
  }

  renderOldRetakeCharts (progressArray) {
    const { selectedStudent } = this.props

    // questionsReceived is an alias for qr so that it does not conflict with qr in the forEach method below
    return progressArray.map(({ tp, qr: questionsReceived }, i, a) => {
      let totalPointsEarned = 0
      let totalPointsAvailable = 0
      let totalQuestionsReceived = 0
      const topicalPointsEarned = []
      const topicalPointsAvailable = []

      tp.forEach(({ pe, pa, qr }) => {
        totalPointsEarned += pe
        totalPointsAvailable += pa
        totalQuestionsReceived += qr
        topicalPointsEarned.push(pe)
        topicalPointsAvailable.push(pa)
      })

      // DEV NOTE: the qr property in the tp array of objects does not reflect the rt.qr totalQuestionsReceived
      if (questionsReceived !== undefined) {
        totalQuestionsReceived = questionsReceived
      }
      selectedStudent.questionsReceived = totalQuestionsReceived

      const overallAccuracy = Math.round(100 * totalPointsEarned / totalPointsAvailable)
      const inProgressLabel = progressArray[i].score >= progressArray[i].target
        ? <p className={style.scoreLabel}>{`${totalQuestionsReceived} questions`}</p>
        : <p className={classnames(style.scoreLabel)}>
          {`In progress (${totalQuestionsReceived} ${totalQuestionsReceived === 1 ? 'question' : 'questions'})`}
        </p>

      // First attempt score should have label and X close icon
      return (
        <TopicItem
          key={i}
          index={i}
          showClassComparison={this.state.showClassComparison}
          overallAccuracy={isNaN(overallAccuracy) ? 0 : overallAccuracy}
          inProgressLabel={inProgressLabel}
          totalPointsEarned={topicalPointsEarned}
          totalPointsAvailable={topicalPointsAvailable}
          topics={this.props.activity.topics}
          classPercentage={this.props.accuracyAverage}
          questionsReceived={totalQuestionsReceived}
        />
      )
    })
  }

  // This panel displays First Attempt and Most Recent Retake
  // The below instance methods are associated with this panel.
  renderRecentRetakes () {
    const { selectedStudent, setSelectedStudent } = this.props
    const percentage = this.props.accuracyAverage
    const isCompleted = selectedStudent
      ? selectedStudent.activity_state.score >= selectedStudent.activity_state.target
      : false
    const toolTipText = 'This is a total average accuracy score for this activity based on the ' +
    'individual student accuracy scores your students achieved upon reaching the target score.'

    if (selectedStudent === null && this.averageCheckbox) {
      this.averageCheckbox.checked = false
    }

    const { width } = this.props.browser
    const isMobile = width < 769

    const isMobileStudentDetail = isMobile && selectedStudent

    return (
      <div>
        <div className={selectedStudent != null ? style.retakeHeader : panelStyle.base}>
          <h2 className={style.studyPlanHeader} data-test-id="activityPerformanceLabel">
            Activity Performance: <span className={style.studyPlanTitle}>{selectedStudent ? selectedStudent.name : 'All Students'}</span>
          </h2>
          {!isMobile && selectedStudent &&
          <Clickable
            data-test-id="closeStudentDetailBtn"
            onClick={(event) => setSelectedStudent(null)}
            className={classnames(style.closeXClick, style.closeStudentDetails)}
          >
            <input
              type="image"
              alt={'Close student detail'}
              src={closeIcon}
              className={base.svgIcon}
            />
          </Clickable>}
          <button
            data-test-id="closeStudentDetailBtn"
            aria-label="Close student detail"
            className={classnames(!isMobileStudentDetail && style.hide, style.hideDetail)}
            onClick={this.props.onBackClick}
            tabIndex="0"
          >
            <object
              tabIndex="-1"
              data={closeIcon} type="image/svg+xml"
              className={base.svgIcon}
            />
          </button>
          <div className={style.checkboxSection} style={{ display: selectedStudent && isCompleted ? 'block' : 'none' }}>
            <input
              type="checkbox"
              name="classScoreSelected"
              aria-label={'Class Average Checkbox'}
              defaultChecked={false}
              onChange={this.onCheckboxSelected}
              ref={ref => { this.averageCheckbox = ref }}
              tabIndex="0"
              id="classAverageCheckboxRecentRetakes"
            />
            <label
              className={style.classAverageLabel}
              htmlFor="classAverageCheckboxRecentRetakes"
            >
              <span className={style.classAverageCheckbox}>
                Show Class Average Comparisons
              </span>
            </label>
            {!isMobile &&
              selectedStudent &&
              selectedStudent.lcrp_progress &&
              selectedStudent.lcrp_progress.ra.length > 0
              ? (
                <span
                  className={style.viewRetakesLabel}
                  onClick={this.onToggleRetakeCharts}
                  data-test-id="topicPerformanceViewRetakesBtn"
                >
                View All Retakes
                </span>
                )
              : null}
          </div>
          <Row style={{ display: selectedStudent ? 'none' : 'flex', alignItems: 'center', marginBottom: 20 }}>
            <Col xs={8} sm={8} md={8} lg={10}>
              <p className={style.progressAccuracyLabel}>Average Accuracy:</p>
              {this.renderAccuracyBar(percentage)}
              <OverlayTrigger
                overlay={<Tooltip id={'calculationTooltip'}>{toolTipText}</Tooltip>}
                placement="bottom"
                delayShow={300}
                delayHide={150}
              >
                <span className={style.tooltipHover}>How is this calculated?</span>
              </OverlayTrigger>
            </Col>
            <Col xs={4} sm={4} md={4} lg={2} className={style.accuracyCol}>
              {!isMobile &&
                <p className={style.accuracyLabelScore}>Accuracy</p>
              }
              <br />
              <span
                data-test-id="classAverageAccuracy"
                className={style.accuracyValue}
              >
                {this.renderGradedDot(percentage)}
              </span>
            </Col>
          </Row>
          {!selectedStudent &&
          <>
            <p className={style.topicAccuracyLabelScore}>Accuracy</p>
            <h2 className={style.studyPlanHeaderSub}>
              Topic Performance
            </h2>
          </>}
          {isMobile && !selectedStudent &&
            <h2 className={style.mobileTopicPerformance}>
              {selectedStudent ? `Topic Performance: ${selectedStudent.name}` : 'Topic Performance: All Students'}
            </h2>
          }
        </div>
        {!selectedStudent ? this.renderRecentTopics() : null}
        {selectedStudent ? this.renderRecentScores() : null}
        {isMobile &&
         selectedStudent &&
         selectedStudent.lcrp_progress &&
         selectedStudent.lcrp_progress.ra.length > 0
          ? (
            <button
              className={classnames(panelStyle.base, style.mobileRetakeButton)}
              onClick={this.onToggleRetakeCharts}
              data-test-id="topicPerformanceViewRetakesBtn"
            >
            View All Retakes
            </button>
            )
          : null}
      </div>
    )
  }

  renderRecentScores () {
    const classPercentage = this.props.accuracyAverage
    const { activity_state, lcrp_progress, score, grade, completedTimestamp, timeOnTask } = this.props.selectedStudent
    const { width } = this.props.browser
    const hintCount = activity_state.hintCount

    let totalPointsEarned = 0
    let totalPointsAvailable = 0
    let totalQuestionsReceived = 0
    let overallAccuracy = 0
    const hrTick = (
      <div>
        <p className={style.hrLabel} style={{ left: (classPercentage - 8) + '%' }}>Class Avg.</p>
        <hr className={style.classAvgHr} style={{ left: classPercentage + '%' }} />
        <p className={style.hrPercent} style={{ left: (classPercentage - 2) + '%' }}>{classPercentage}%</p>
      </div>
    )

    if (score > 0) {
      activity_state.tp.forEach(({ pe, pa, qr }) => {
        totalPointsEarned += pe
        totalPointsAvailable += pa
        totalQuestionsReceived += qr
      })
      overallAccuracy = Math.round(100 * totalPointsEarned / totalPointsAvailable)
    }
    totalQuestionsReceived = activity_state.qr ? activity_state.qr : totalQuestionsReceived
    const questionSkipCount = totalQuestionsReceived > activity_state.completedQuestionCount
      ? totalQuestionsReceived - activity_state.completedQuestionCount
      : 0
    const totalQuizTimeInMs = timeOnTask ? timeOnTask * 1000 : 0
    const totalQuizTime = msToTime(totalQuizTimeInMs)
    const avgAnswerSpeed = msToTime(totalQuizTimeInMs / totalQuestionsReceived)

    const smallRetakeProgress = () => {
      if (activity_state.rt === undefined && grade === 100) {
        return (
          <div className={classnames(style.recentRetakeWrapper, panelStyle.base)}>
            <Col className={style.chartLabels}>
              <p>Practice Retake:</p>
              <p className={style.scoreLabel}>Not started</p>
            </Col>
          </div>
        )
      } else if (activity_state.rt !== undefined && activity_state.rt.score < activity_state.rt.target) {
        return (
          <div className={classnames(style.recentRetakeWrapper, panelStyle.base)}>
            <Col className={style.chartLabels}>
              <p>Practice Retake:</p>
              <p className={classnames(style.scoreLabel)}>
                {`In progress (${activity_state.rt.qr} ${activity_state.rt.qr === 1 ? 'question' : 'questions'})`}
              </p>
            </Col>
          </div>
        )
      } else if (activity_state.rt !== undefined && activity_state.rt.score >= activity_state.rt.target) {
        let totalPointsEarned = 0
        let totalPointsAvailable = 0

        activity_state.rt.tp.forEach(({ pe, pa }) => {
          // eslint-disable-next-line no-unused-vars
          totalPointsEarned += pe
          // eslint-disable-next-line no-unused-vars
          totalPointsAvailable += pa
        })

        return (
          <div style={{ display: 'flex', alignItems: 'center' }} className={panelStyle.base}>
            {this.renderRecentRetakeScore({ activity_state, lcrp_progress, grade })}
          </div>
        )
      }
    }

    if (width <= 991) {
      return (
        <div>
          <div key={0} className={panelStyle.base}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Col xs={9} sm={9} className={style.chartLabels}>
                <p
                  className={style.resultsLabel}
                  data-test-id="topicPerformanceQuizResults"
                >Quiz Results ({totalQuestionsReceived} questions):</p>
                {this.state.showClassComparison ? hrTick : null}
                {this.renderAccuracyBar(overallAccuracy)}
              </Col>
              <Col xs={3} sm={3} style={{ paddingLeft: '5px', paddingRight: '0px' }}>
                <div className={style.percentage} style={{ fontSize: '18px' }}>
                  <p className={style.accuracyDot}>Accuracy</p>
                  {this.renderGradedDot(overallAccuracy)}
                </div>
              </Col>
            </div>
            <Row className={style.studentStats}>
              <Col sm={4}>
                <p>Time Spent</p>
                <p
                  className={style.studentStatsValue}
                  data-test-id="topicAndPerformanceQuizTimeSpent"
                >{totalQuizTime}</p>
              </Col>
              <Col sm={4}>
                <p>Average Answer Speed</p>
                <p
                  className={style.studentStatsValue}
                  data-test-id="topicAndPerformanceQuizAverageAnswerSpeed"
                >{avgAnswerSpeed}/question</p>
              </Col>
              <Col sm={4}>
                <p>Hints Taken
                  <span
                    className={style.studentStatsValue}
                    data-test-id="topicAndPerformanceQuizHintsTaken"
                  > {hintCount}</span>
                </p>
                <p>Questions Skipped
                  <span
                    className={style.studentStatsValue}
                    data-test-id="topicAndPerformanceQuizQuestionsSkip"
                  > {questionSkipCount}</span>
                </p>
              </Col>
              <Col sm={4}>
                <p>Target Score Reached</p>
                <p
                  className={style.studentStatsValue}
                  data-test-id="topicAndPerformanceQuizCompletedTimestamp"
                > {moment.utc(completedTimestamp).local().format('ddd, MMM D, h:mma')}
                </p>
              </Col>
            </Row>

            {this.state.showScoreDetails &&
            <p className={style.selectedTopicAccuracyLabelScore}>Accuracy</p>}
            <Clickable
              className={style.showRetakes}
              onClick={() => this.setState({ showScoreDetails: !this.state.showScoreDetails })}
              data-test-id="topicPerformanceDetailBtn"
            >
              {this.state.showScoreDetails
                ? <img aria-hidden="true" className={style.topicCaret} src={caretDown} alt={'caret expanded'} />
                : <img aria-hidden="true" className={style.topicCaret} src={caretRight} alt={'caret collapsed'} />
              }
              {this.state.showScoreDetails ? 'Hide Topic Performance' : 'Show Topic Performance'}
            </Clickable>
            {this.state.showScoreDetails ? this.renderTopics() : null}
          </div>
          {smallRetakeProgress()}
        </div>
      )
    }

    if (activity_state.score < activity_state.target) {
      const questionLabel = totalQuestionsReceived === 1 ? 'question' : 'questions'
      return (
        <div className={panelStyle.base}>
          <p className={classnames(style.scoreLabel)}>
            {`In progress (${totalQuestionsReceived} ${questionLabel})`}
          </p>
        </div>
      )
    }
    return (
      <div key={0}>
        <div className={panelStyle.base}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Col xs={9} sm={9} className={style.chartLabels}>
              <p className={style.resultsLabel}>Quiz Results ({totalQuestionsReceived} questions):</p>
              {this.state.showClassComparison ? hrTick : null}
              {this.renderAccuracyBar(overallAccuracy)}
            </Col>
            <Col xs={3} sm={3} style={{ paddingRight: '10px' }}>
              <div className={style.percentage}>
                <p className={style.accuracyDot}>Accuracy</p>
                {this.renderGradedDot(overallAccuracy)}
              </div>
            </Col>
          </div>
          <Row className={style.studentStats}>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Time Spent: </span>
              <span className={style.studentStatsValue} data-test-id="topicAndPerformanceQuizTimeSpent">{totalQuizTime}</span>
            </Col>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Average Answer Speed: </span>
              <span
                className={style.studentStatsValue}
                data-test-id="topicAndPerformanceQuizAverageAnswerSpeed"
              >{avgAnswerSpeed}/question</span>
            </Col>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Hints Taken: </span>
              <span
                className={style.studentStatsValue}
                data-test-id="topicAndPerformanceQuizHintsTaken"
              > {hintCount}</span>
            </Col>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Questions Skipped: </span>
              <span
                className={style.studentStatsValue}
                data-test-id="topicAndPerformanceQuizQuestionsSkip"
              > {questionSkipCount}</span>
            </Col>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Target Score Reached: </span>
              <span
                className={style.studentStatsValue}
                data-test-id="topicAndPerformanceQuizCompletedTimestamp"
              > {moment.utc(completedTimestamp).local().format('ddd, MMM D, h:mma')}
              </span>
            </Col>
          </Row>
          {this.state.showScoreDetails &&
          <p className={style.selectedTopicAccuracyLabelScore}>Accuracy</p>}
          <Clickable
            className={style.showRetakes}
            onClick={() => this.setState({ showScoreDetails: !this.state.showScoreDetails })}
            data-test-id="topicPerformanceDetailBtn"
          >
            {this.state.showScoreDetails
              ? <img aria-hidden="true" className={style.topicCaret} src={caretDown} alt={'caret expanded'} />
              : <img aria-hidden="true" className={style.topicCaret} src={caretRight} alt={'caret collapsed'} />
            }
            {this.state.showScoreDetails ? 'Hide Topic Performance' : 'Show Topic Performance'}
          </Clickable>
          {this.state.showScoreDetails ? this.renderTopics() : null}
        </div>
        <div style={{ display: 'flex', alignItems: 'center' }} className={panelStyle.base}>
          {this.renderRecentRetakeScore({ activity_state, lcrp_progress, grade })}
        </div>
      </div>
    )
  }

  renderRecentRetakeScore ({ activity_state: { rt }, lcrp_progress, grade }) {
    const classPercentage = this.props.accuracyAverage
    const hrTick = (
      <div>
        <p className={style.hrLabel} style={{ left: (classPercentage - 8) + '%' }}>Class Avg.</p>
        <hr className={style.classAvgHr} style={{ left: classPercentage + '%' }} />
        <p className={style.hrPercent} style={{ left: (classPercentage - 2) + '%' }}>{classPercentage}%</p>
      </div>
    )
    // Student completed quiz but hasn't started a retake yet
    if (rt === undefined && grade === 100) {
      return (
        <Col sm={6} className={style.chartLabels}>
          <p>Practice Retake:</p>
          <p className={style.scoreLabel}>Not started</p>
          {/* Gross style hack until I find a better way */}
          <p style={{ visibility: 'hidden' }}>Not started</p>
        </Col>
      )
    } else if (rt !== undefined && rt.score < rt.target) {
      return (
        <Col sm={6} className={style.chartLabels}>
          <p>Practice Retake:</p>
          <p className={classnames(style.scoreLabel)}>
            In progress ({`${rt.qr} ${rt.qr === 1 ? 'question' : 'questions'}`})
          </p>
        </Col>
      )
    } else if (rt !== undefined && rt.score >= rt.target) {
      const { tp } = rt
      let totalPointsEarned = 0
      let totalPointsAvailable = 0
      const questionSkipCount = rt.qr > rt.completedQuestionCount
        ? rt.qr - rt.completedQuestionCount
        : 0

      tp.forEach(({ pe, pa }) => {
        totalPointsEarned += pe
        totalPointsAvailable += pa
      })
      const completedTimestamp = _.last(rt.quizTimes)?.completedTimestamp
      const totalQuestionsReceived = rt.qr ? rt.qr : 0
      const overallRetakeAccuracy = Math.round(100 * totalPointsEarned / totalPointsAvailable)
      const questionLabel = rt.qr === 1 ? 'question' : 'questions'
      const totalQuizTimeInMs = calculateTotalTime(rt.quizTimes)
      const totalQuizTime = msToTime(totalQuizTimeInMs)
      const avgAnswerSpeed = msToTime(totalQuizTimeInMs / totalQuestionsReceived)
      const hintCount = rt.hintCount || 0
      return ([
        <div className={classnames(style.recentRetakeWrapper)} key={1}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Col xs={9} sm={9} className={style.chartLabels}>
              <p className={style.resultsLabel}>Most Recent Retake ({`${rt.qr} ${questionLabel}`}):</p>
              {this.state.showClassComparison ? hrTick : null}
              {this.renderAccuracyBar(overallRetakeAccuracy)}
            </Col>
            <Col xs={3} sm={3} style={{ paddingRight: '10px' }}>
              <div className={style.percentage}>
                <p className={style.accuracyDot}>Accuracy</p>
                {this.renderGradedDot(overallRetakeAccuracy)}
              </div>
            </Col>
          </div>
          <Row className={style.studentStats}>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Time Spent: </span>
              <span className={style.studentStatsValue} data-test-id="topicAndPerformanceQuizTimeSpent">{totalQuizTime}</span>
            </Col>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Average Answer Speed: </span>
              <span
                className={style.studentStatsValue}
                data-test-id="topicAndPerformanceQuizAverageAnswerSpeed"
              >{avgAnswerSpeed}/question</span>
            </Col>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Hints Taken: </span>
              <span
                className={style.studentStatsValue}
                data-test-id="topicAndPerformanceQuizHintsTaken"
              > {hintCount}</span>
            </Col>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Questions Skipped: </span>
              <span
                className={style.studentStatsValue}
                data-test-id="topicAndPerformanceQuizQuestionsSkip"
              > {questionSkipCount}</span>
            </Col>
            <Col className={style.studentStatsItem} sm={12}>
              <span className={style.studentStatsLabel}>Target Score Reached: </span>
              <span
                className={style.studentStatsValue}
                data-test-id="topicAndPerformanceQuizCompletedTimestamp"
              > {moment.utc(completedTimestamp).local().format('ddd, MMM D, h:mma')}
              </span>
            </Col>
          </Row>
          {this.state.showRetakeDetails &&
          <p className={style.selectedTopicAccuracyLabelScore}>Accuracy</p>}
          <Clickable
            className={style.showRetakes}
            onClick={() => this.setState({ showRetakeDetails: !this.state.showRetakeDetails })}
            data-test-id="topicPerformanceDetailBtn"
          >
            {this.state.showRetakeDetails
              ? <img aria-hidden="true" className={style.topicCaret} src={caretDown} alt={'caret expanded'} />
              : <img aria-hidden="true" className={style.topicCaret} src={caretRight} alt={'caret collapsed'} />
            }
            {this.state.showRetakeDetails ? 'Hide Topic Performance' : 'Show Topic Performance'}
          </Clickable>
          {this.state.showRetakeDetails ? this.renderTopics(true) : null}
        </div>
      ])
    } else {
      return null
    }
  }

  // This component uses class averages and first attempt scores...
  // ...and renders a black dot for topical comparison.
  renderRecentTopics () {
    const { activity, itemClick } = this.props

    return activity.allTopics.map((topic) => {
      const isActive = _.some(activity.topics, (activeTopic) => {
        return topic.label === activeTopic.label
      })

      const classPointsAvailable = topic.class_points_available * 1
      const classPointsEarned = topic.class_points_earned * 1
      const originalPointsAvailable = 0
      const originalPointsEarned = 0

      // Radio button logic.
      const { classScoreSelected, originalScoreSelected } = this.props

      const hasQuestions = topic.totalQuestions > 0

      return (
        <LCRPStudyPlanItem
          itemClick={itemClick}
          key={topic.label}
          label={topic.label}
          studyPlan={topic.studyPlan}
          disableLinks={activity.config.disableLinks}
          startedStudents={activity.studentData.started_students}
          classPointsAvailable={classPointsAvailable}
          classPointsEarned={classPointsEarned}
          originalPointsAvailable={originalPointsAvailable}
          originalPointsEarned={originalPointsEarned}
          totalPointsAvailable={classPointsAvailable}
          totalPointsEarned={classPointsEarned}
          hasQuestions={hasQuestions}
          isActive={isActive}
          selectedStudent={null}
          originalScoreSelected={originalScoreSelected}
          classScoreSelected={classScoreSelected}
          width={this.props.browser.width}
        />
      )
    })
  }

  renderTopics (recentRetake = false) {
    const {
      activity,
      selectedStudent
    } = this.props

    const topicItems = activity.allTopics.map((topic, i) => {
      let totalPointsAvailable = 0
      let totalPointsEarned = 0

      const studentIdx = _.findIndex(activity.students, (student) => {
        return student.id === selectedStudent.id
      })

      if (recentRetake) {
        if (selectedStudent && selectedStudent.activity_state.rt) {
          totalPointsAvailable = selectedStudent.activity_state.rt.tp[topic.topicId].pa * 1
          totalPointsEarned = selectedStudent.activity_state.rt.tp[topic.topicId].pe * 1
        }
      } else {
        if (selectedStudent) {
          totalPointsAvailable = topic.pa_arr[studentIdx] * 1
          totalPointsEarned = topic.pe_arr[studentIdx] * 1
        }
      }

      const hasQuestions = topic.totalQuestions > 0

      return (
        <StudyPlanItem
          key={topic.label}
          label={topic.label}
          totalPointsAvailable={totalPointsAvailable}
          totalPointsEarned={totalPointsEarned}
          hasQuestions={hasQuestions}
          disableLinks={true}
          isActive={true}
          fromLCRPInstructor={true}
        />
      )
    })
    return (
      <div>
        <div className={style.topicItemsContainer}>
          {topicItems}
        </div>
      </div>
    )
  }

  renderGradedDot (score) {
    if (score === 0 || isNaN(score)) {
      return '-- %'
    }
    let gradedDot = greenDot
    if (score < 70) {
      gradedDot = redDot
    } else if (score < 90) {
      gradedDot = yellowDot
    }
    return ([
      <img
        key={score}
        src={gradedDot}
        className={classnames(iconStyle.small, style.gradedDotImg)}
        alt={'graded dot'}
        tabIndex="-1"
      />,
      <label className={classnames(iconStyle.textIcon, iconStyle.textActivityPerformance)}>{score}%</label>
    ])
  }

  render () {
    return this.state.showRetakeCharts ? this.renderAllRetakes() : this.renderRecentRetakes()
  }
}

TopicPerformanceDetail.propTypes = {
  browser: PropTypes.object,
  onTopicButtonClick: PropTypes.func,
  activity: PropTypes.object,
  selectedStudent: PropTypes.object,
  setSelectedStudent: PropTypes.func,
  classAverage: PropTypes.number,
  updateRadioButtons: PropTypes.func,
  classScoreSelected: PropTypes.bool,
  originalScoreSelected: PropTypes.bool,
  itemClick: PropTypes.func,
  onBackClick: PropTypes.func,
  accuracyAverage: PropTypes.number
}
